<template>
    <span v-if="credits.length === 0">No transactions.</span>
    <DataTable :value="credits" v-else class="p-datatable-sm" stripedRows breakpoint="992px"
        v-model:expandedRows="expandedRowsCredits" dataKey="id" id="credits-table" responsiveLayout="stack"
        sortField="created_at" :sortOrder="-1">
        <Column field="created_at" header="Date" :sortable="true">
            <template #body="slotProps">
                {{ moment(slotProps.data.created_at).format('M/D/YY h:mm A') }}
            </template>
        </Column>
        <Column field="description" header="Description">
            <template #body="slotProps">
                <inertia-link v-if="slotProps.data.link && slotProps.data.customer_id"
                    :href="route(slotProps.data.link[0], slotProps.data.link[1])">
                    {{ slotProps.data.description }}
                </inertia-link>
                <span class="text-right" v-else>
                    {{ slotProps.data.description }}
                </span>
            </template>
        </Column>
        <Column field="customer" header="Customer">
            <template #body="slotProps">
                <inertia-link v-if="slotProps.data.customer_id" :href="route('tu.view', slotProps.data.customer_id)">
                    {{ slotProps.data.customer }}
                </inertia-link>
                <span v-else>
                    {{ slotProps.data.customer }}
                </span>
            </template>
        </Column>
        <Column field="credit_amount" header="Amount" headerClass="header-right" class="table-right">
            <template #body="slotProps">
                {{ formatDollars(slotProps.data.credit_amount) }}
            </template>
        </Column>
        <Column class="width-full expander" :expander="true" headerStyle="width: 3em" />
        <template #expansion="slotProps">
            <div class="transaction-details w-100">
                <div v-if="slotProps.data.details.type == 'return'">
                    <table>
                        <tr class="d-flex justify-content-between">
                            <td>Description</td>
                            <td class="text-right">{{ slotProps.data.details.description }}</td>
                        </tr>
                    </table>
                </div>
                <div v-else-if="slotProps.data.details.type == 'order'">
                    <table>
                        <tr class="d-flex justify-content-between">
                            <td>Customer Total</td>
                            <td class="text-right">+{{ formatDollars(slotProps.data.details.products_total_user) }}</td>
                        </tr>
                        <tr class="d-flex justify-content-between">
                            <td>Your Cost</td>
                            <td class="text-right">-{{ formatDollars(slotProps.data.details.products_total_mtd) }}</td>
                        </tr>
                        <tr class="d-flex justify-content-between">
                            <td>Shipping</td>
                            <td>+{{ formatDollars(slotProps.data.details.shipping_cost) }}</td>
                        </tr>
                        <tr class="d-flex justify-content-between">
                            <td>Sales Tax</td>
                            <td class="text-right">+{{ formatDollars(slotProps.data.details.sales_tax_amount) }}</td>
                        </tr>
                        <tr class="d-flex justify-content-between">
                            <td>Processing Fee</td>
                            <td class="text-right">-{{ formatDollars(slotProps.data.details.processing_fees_mtd) }}</td>
                        </tr>
                    </table>
                </div>
                <div v-else-if="slotProps.data.details.type == 'payment'">
                    <table>
                        <tr class="d-flex justify-content-between">
                            <td>Customer Total</td>
                            <td class="text-right">+{{ formatDollars(slotProps.data.details.total_amount) }}</td>
                        </tr>
                        <tr class="d-flex justify-content-between">
                            <td>Processing Fee</td>
                            <td class="text-right">-{{ formatDollars(slotProps.data.details.processing_fees_mtd) }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </template>
    </DataTable>

    <div class="float-right">
        <strong>Total:</strong> {{ formatDollars(credits_total) }}
    </div>
</template>

<script>
import moment from 'moment'

export default {
    data() {
        return {
            expandedRowsCredits: [],
        }
    },
    props: {
        credits_total: Number,
        credits: Array
    },
    created() {
        this.moment = moment
    }
}
</script>
